const UploadFiles_Icon = ({ fill, stroke, className }) => {
  return (
    <svg
      width="29"
      height="28"
      className={className}
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1124 4.9001C16.1124 4.27557 15.596 3.6501 14.8624 3.6501C14.1511 3.6501 13.5156 4.25751 13.6124 5.00116V14.3923L11.2413 12.0212C10.9417 11.7216 10.6285 11.6126 10.3124 11.6126C10.1418 11.6126 9.95907 11.6679 9.80203 11.7404C9.64386 11.8134 9.49143 11.9132 9.38348 12.0212C8.86788 12.5368 8.86788 13.3634 9.38348 13.879L13.846 18.3415C14.1456 18.6411 14.4588 18.7501 14.7749 18.7501C14.9455 18.7501 15.1282 18.6948 15.2853 18.6223C15.4434 18.5493 15.5959 18.4495 15.7038 18.3415L20.3413 13.704C20.8569 13.1884 20.8569 12.3618 20.3413 11.8462C20.0417 11.5466 19.7285 11.4376 19.4124 11.4376C19.2418 11.4376 19.0591 11.4929 18.902 11.5654C18.7439 11.6384 18.5914 11.7382 18.4835 11.8462L16.1124 14.2173V4.9001Z"
        fill={fill}
        stroke={stroke}
        stroke-width="0.4"
      />
      <path
        d="M4.01245 24.8375H25.1C25.779 24.8375 26.225 24.2715 26.225 23.7125V16.45C26.225 16.1306 26.1174 15.8451 25.9111 15.6388C25.7048 15.4325 25.4193 15.325 25.1 15.325C24.7806 15.325 24.4951 15.4325 24.2888 15.6388C24.0825 15.8451 23.975 16.1306 23.975 16.45V22.5875H5.13745V16.45C5.13745 16.1306 5.02992 15.8451 4.8236 15.6388C4.61728 15.4325 4.33176 15.325 4.01245 15.325C3.69314 15.325 3.40762 15.4325 3.2013 15.6388C2.99498 15.8451 2.88745 16.1306 2.88745 16.45V23.7125C2.88745 24.0318 2.99498 24.3173 3.2013 24.5236C3.40762 24.7299 3.69314 24.8375 4.01245 24.8375Z"
        fill={fill}
        stroke={stroke}
        stroke-width="0.5"
      />
    </svg>
  );
};

export default UploadFiles_Icon;
